import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import Protocol from './protocol';
import { invoke } from './lib/tenvideo';
import { parse } from './util/cookie';
/**
 * mac 客户端 JSBridge 接口
 * @extends Protocol
 */

var MacJSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(MacJSBridge, _Protocol);

  var _super = _createSuper(MacJSBridge);

  function MacJSBridge() {
    _classCallCheck(this, MacJSBridge);

    return _super.apply(this, arguments);
  }

  _createClass(MacJSBridge, [{
    key: "openPay",

    /**
     * 购买 VIP，包月或单点购买
     * @param [options] {Object} - Pay options
     * @param [options.type] {String} - 支付类型，openVip：按月购买，singlePay：单片购买
     * @param [options.product_id] {String} - 商品 id
     * @param [options.count] {Number} - 购买数量
     * @param [options.price] {Number} - 商品价格
     * @param [options.saveValue] {Number} - 未知，如：1 3 6 12
     * @param [options.auto_renewal] {String} - 是否连续包月
     * @param [options.aid] {String} - 根据特定规则拼接的 aid 字符串，用于平台、版本号等
     * @returns {Promise}
     * @example <caption>eg 1. 按月购买</caption>
     * atom.openPay({
     *     type: 'openVip'
     *     product_id:,
     *     count, // 现在传1
     *     price, // 价格
     *     saveValue, // 1 3 6 12
     *     aid,
     *     auto_renewal // 连续包月 暂时没用到
     * })
     * @example <caption>eg 2. 单点购买</caption>
     * atom.openPay({
     *     type: 'singlePay',
     *     product_id,
     *     count, // 现在传1
     *     price, // 价格
     *     saveValue, // 格式为 'cid*PRICE*SAVE_VALUE' SAVE_VALUE为1
     *     aid,
     * })
     */
    value: function openPay() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('vipPurchase', options);
    }
  }, {
    key: "openLogin",
    value: function openLogin() {
      return invoke('login');
    }
  }, {
    key: "switchLogin",
    value: function switchLogin() {
      return invoke('switchAccount');
    }
    /**
     * 退出登录
     * @returns {Promise}
     */

  }, {
    key: "logout",
    value: function logout() {
      return invoke('logout');
    }
    /**
     * 获取 Cookie
     * @returns {Promise}
     */

  }, {
    key: "getMainCookie",
    value: function getMainCookie() {
      return Promise.resolve(parse(document.cookie));
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      return invoke('getUserInfo');
    }
    /**
     * 获取设备信息
     * @returns {Promise} test - A Promise resolve Object
     */

  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      return this.getMainCookie().then(function (cookie) {
        var systemVersion = navigator.userAgent.match(/Mac OS X ([0-9]{1,2}_){2}[0-9]{2}/);
        return {
          guid: cookie.guid,
          omgid: 0,
          deviceModel: 'Mac',
          systemVersion: systemVersion ? systemVersion[1] : '',
          screenWidth: window.screen.width,
          screenHeight: window.screen.height
        };
      });
    }
    /**
     * 获取设备信息
     * @returns {Promise} test - A Promise resolve Object
     */

  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      return invoke('getSystemInfo').then(function (res) {
        return {
          'isJBOS': 0,
          'buildVersion': res.clientBuildVersion,
          'supportiap': location.search.indexOf('AppStore=1') > -1,
          'isinreview': false,
          'version': res.clientVersion,
          'pkgName': 'com.tencent.qqlive'
        };
      });
    }
    /**
     * 获取系统网络状态
     * @returns {Promise} A promise resolve Object
     * @property {number}  result.status      - 是否有网，1/0
     * @property {number}  result.type        - 网络类型
     */

  }, {
    key: "getNetworkState",
    value: function getNetworkState() {
      return invoke('getNetworkInfo');
    }
    /**
     * 客户端当前版本的远程配置
     * @returns {Promise}
     * @property {Boolean} result.GUI.displayPurchaseButtonInUserCenter - 是否显示VIP信息
     */

  }, {
    key: "getRemoteConfigs",
    value: function getRemoteConfigs() {
      return invoke('getRemoteConfigs');
    }
    /**
     * 获取用户登录状态
     * @returns {Promise} A Promise resolve value
     * @property {number} result.status - 0登录中, 1已登录, -1未登录
     */

  }, {
    key: "getLoginStatus",
    value: function getLoginStatus() {
      return invoke('getLoginStatus');
    }
    /**
     * 切换登录账号
     * @returns {Promise}
     */

  }, {
    key: "switchAccount",
    value: function switchAccount() {
      return invoke('switchAccount');
    }
    /**
     * 获取单片购买成功状态
     * @returns {Promise}
     */

  }, {
    key: "payForFilmSuccess",
    value: function payForFilmSuccess() {
      return invoke('onPurchaseSuccessed');
    }
    /**
     * 获取购买成功会员状态
     * @returns {Promise}
     */

  }, {
    key: "vipInfoChangeSuccess",
    value: function vipInfoChangeSuccess() {
      return invoke('onProfileForQQLiveDidUpdated');
    }
    /**
     * 打开由上至下弹出的窗口
     * @param {String} url - 页面地址
     */

  }, {
    key: "openSheetWindow",
    value: function openSheetWindow(url) {
      return invoke('openSheetWindow', {
        url: url
      });
    }
  }, {
    key: "closeSheetWindow",
    value: function closeSheetWindow() {
      return invoke('closeSheetWindow');
    }
    /**
     * 打开由中间弹出的浮层窗口
     * @param {String} url - 页面地址
     * @param {Number} options.width - 窗口宽度
     * @param {Number} options.height - 窗口高度
     * @example
     * atom.openModalWindow('https://film.qq.com/minipay/', {
     *   width: 860,
     *   height: 600
     * })
     */

  }, {
    key: "openModalWindow",
    value: function openModalWindow() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return invoke('openModalWindow', _objectSpread({
        url: url
      }, options));
    }
    /**
     * 关闭浮层窗口
     * @returns {Promise}
     */

  }, {
    key: "closeModalWindow",
    value: function closeModalWindow() {
      return invoke('closeModalWindow');
    }
    /**
     * 设置 window 大小
     * @returns {Promise}
     */

  }, {
    key: "setWindowSize",
    value: function setWindowSize() {
      return invoke('setWindowSize');
    }
    /**
     * 显示或隐藏窗口
     * @returns {Promise}
     */

  }, {
    key: "setViewVisibility",
    value: function setViewVisibility() {
      var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return invoke('setViewVisibility', {
        visible: isVisible
      });
    }
    /**
     * 获取窗口显示或隐藏状态
     * @returns {Promise}
     */

  }, {
    key: "getViewVisibility",
    value: function getViewVisibility() {
      return invoke('getViewVisibility');
    }
    /**
     * 前往播放页
     * @param [options] {Object} - 影片信息
     * @param [options.lid] {String} - 未知
     * @param [options.vid] {String} - 影片id
     * @param [options.cid] {String} - 专辑id
     * @param [options.startTime] {String|optional} - 跳过片头时间
     * @param [options.qs] {String} - 其他参数
     * @example
     * atom.play({
     *      lid: "",
     *      vid: "",
     *      cid: "",
     *      startTime: 0,  // 跳过片头时间
     *      qs: "aaa=111&bbb=222"
     * })
     */

  }, {
    key: "play",
    value: function play() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('play', options);
    }
    /**
     * 播放直播影片
     * @param [options] {Object} - 直播信息 { pid: "", sid: "" }
     * @param [options.pid] {String} - 未知
     * @param [options.sid] {String} - 未知
     * @returns {Promise}
     * @example
     * atom.playLive({
     *      pid: "",
     *      sid: ""
     * })
     */

  }, {
    key: "playLive",
    value: function playLive() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('play', {
        params: params
      });
    }
    /**
     * 隐藏 Loading 动画
     * @returns {Promise}
     */

  }, {
    key: "closeLoading",
    value: function closeLoading() {
      return invoke('stopPageLoadingAnimation');
    }
    /**
     * 打开新的 webview
     * @param {String} url - 页面地址
     * @returns {Promise}
     * @example
     * atom.openUrl('//film.qq.com')
     */

  }, {
    key: "openUrl",
    value: function openUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return invoke('windowOpen', {
        url: url
      });
    }
    /**
     * 发送消息给客户端和窗口页面
     * @param  {String} event 消息的事件名称
     * @param  {Object} args  消息的参数
     * @example
     * atom.postMessage('onPayInfoChanged', {
     *   code: 0
     * })
     */

  }, {
    key: "postMessage",
    value: function postMessage(event, args) {
      args = _typeof(args) === 'object' ? JSON.stringify(args) : '{}';
      return this.invoke('message', {
        event: event,
        data: args
      });
    }
  }]);

  return MacJSBridge;
}(Protocol);

export default new MacJSBridge();